import { CartesianChart } from '@/common/dashboard/charts/CartesianChart';
import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { useEffect, useState } from 'react';

const CHART_GREEN = '#1B5E20';

export const ChbkFinTrendChart = ({ formValues, totalValues, ctrtTypeIdToCtrtType }) => {

  let { invPeriodId, invDate, periodicity, distCustIds, ctrtTypeIds, prodIds, agg } = formValues;

  const { totalProdIds, totalDistCustIds } = totalValues;

  const rsrc = useRsrc();

  const { navigateTo } = useNavState();

  const [data, setData] = useState([]);

  const [finalProdIds, setFinalProdIds] = useState([]);
  const [prodIdsNot, setProdIdsNot] = useState(false);
  // const [finalDistCustIds, setFinalDistCustIds] = useState([]);
  // const [distCustIdsNot, setDistCustIdsNot] = useState(false);

  const chartData = data?.series
    ? {
        ...data,
        series: data.series.map(seriesItem => ({
          ...seriesItem,
          color: CHART_GREEN
        }))
      }
    : data;

  const formatDayCategory = (value) => {
    const raw = String(value ?? '');
    if (raw.length !== 8) {
      return raw;
    }

    const year = raw.substring(0, 4);
    const month = raw.substring(4, 6);
    const day = raw.substring(6, 8);
    return `${month}/${day}/${year}`;
  };

  useEffect(() => {
    if (!invPeriodId && !invDate) {
      return;
    }

    let prodIdsNot = true;
    if (totalProdIds.length / 2 < prodIds.length) {
      prodIds = totalProdIds.filter(id => !prodIds.includes(id));
    } else {
      prodIdsNot = false;
    }
    setFinalProdIds(prodIds);
    setProdIdsNot(prodIdsNot);

    let distCustIdsNot = true;
    if (totalDistCustIds.length / 2 < distCustIds.length) {
      distCustIds = totalDistCustIds.filter(id => !distCustIds.includes(id));
    } else {
      distCustIdsNot = false;
    }
    // setFinalDistCustIds(distCustIds);
    // setDistCustIdsNot(distCustIdsNot);

    const reqParam = {
      periodId: invPeriodId,
      invDate,
      distCustIds,
      distCustIdsNot,
      prodIds,
      prodIdsNot,
      ctrtTypes: ctrtTypeIds.map(id => ctrtTypeIdToCtrtType[id]),
      agg
    };

    rsrc.data('sc', 'CHBK_FIN_TREND_CHART_DATA_PLUGIN', reqParam).then(res => {
      setData(res);
    });

  }, [invPeriodId, invDate, distCustIds, ctrtTypeIds, prodIds, agg]);

  const navigateToClaimLineList = (dataPoint) => {
    const category = dataPoint.category;
    const rowsReq = {};
    if (periodicity === 'MONTH') {
      rowsReq.expr = ExprUtils.whereParams('code', category);
    } else if (periodicity === 'QUARTER') {
      const year = category.substring(0, 4);
      const quarter = category.substring(5);
      const monthStart = (parseInt(quarter) - 1) * 3 + 1;
      const monthPeriodCodes = [monthStart, monthStart + 1, monthStart + 2].map(month => year + 'M' + month.toString().padStart(2, '0'));
      rowsReq.expr = ExprUtils.whereParams('code', monthPeriodCodes);
    } else if (periodicity === 'DAY') {
      const monthPeriodCode = category.substring(0, 4) + 'M' + category.substring(4, 6);
      rowsReq.expr = ExprUtils.whereParams('code', monthPeriodCode);
    }
    rsrc.rows('sc', 'PERIOD', rowsReq).then(periods => {
      const invPeriodIds = periods.map(period => period.id);
      let expr = ExprUtils.whereParams('rcvdPeriodId', invPeriodIds);

      if (finalProdIds.length > 0) {
        let prodExpr;
        if (prodIdsNot) {
          prodExpr = ExprUtils.isNotOneOf('prodId', finalProdIds);
        } else {
          prodExpr = ExprUtils.whereParams('prodId', finalProdIds);
        }
        expr = ExprUtils.and(expr, prodExpr);
      }

      if (periodicity === 'DAY') {
        const dateExpr = ExprUtils.whereParams('rcvdDate', parseInt(category));
        expr = ExprUtils.and(expr, dateExpr);
      }

      // if (finalDistCustIds.length > 0) {
      //   let distCustExpr;
      //   if (distCustIdsNot) {
      //     distCustExpr = ExprUtils.isNotOneOf('chbkClaimPayeeCustId', finalDistCustIds);
      //   } else {
      //     distCustExpr = ExprUtils.whereParams('chbkClaimPayeeCustId', finalDistCustIds);
      //   }
      //   distCustExpr.fkEntity = 'CHBK_CLAIM';
      //   distCustExpr.fkColPrefix = 'chbk_claim';
      //   expr = ExprUtils.and(expr, distCustExpr);
      // }

      // const ctrtExpr = ExprUtils.whereParams('type', ctrtTypeIds.map(id => ctrtTypeIdToCtrtType[id]));
      // ctrtExpr.fkEntity = 'CTRT';
      // ctrtExpr.fkColPrefix = 'ctrt';

      // expr = ExprUtils.and(expr, ctrtExpr);


      const navState = {
        mode: Mode.LIST,
        expr: expr
      };
      navigateTo('/sc/chbk-claim-line', navState);
    });
  }

  return (
    <>
        <CartesianChart
          data={chartData}
          yLabel={agg === 'PAID_AMT' ? 'Paid Amount' : agg === 'NET_AMT' ? 'Net Amount' : 'Paid Quantity'}
          xLabel="Chargeback Period"
          xTickFormatter={periodicity === 'DAY' ? formatDayCategory : undefined}
          allowNegative
          onClick={(dataPoint) => navigateToClaimLineList(dataPoint)}
        />
    </>

  );
};
